/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Notifications_Time_Days_AgoInputs */

const en_notifications_time_days_ago = /** @type {(inputs: Notifications_Time_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}d ago`)
};

const pl_notifications_time_days_ago = /** @type {(inputs: Notifications_Time_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dni temu`)
};

/**
* | output |
* | --- |
* | "{days}d ago" |
*
* @param {Notifications_Time_Days_AgoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_time_days_ago = /** @type {((inputs: Notifications_Time_Days_AgoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Time_Days_AgoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_time_days_ago(inputs)
	return en_notifications_time_days_ago(inputs)
});